import { ChangeEvent, useState } from 'react'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_WORKSPACE_BIDDER_FOR_PAGE } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateWorkspaceBidder, UseUpdateWorkspaceBidderProps } from './types'
import { useSnackbar } from './useSnackbar'

export const useUpdateWorkspaceBidder = ({
  bidderCode,
  enabled,
  id,
}: UseUpdateWorkspaceBidderProps): UseUpdateWorkspaceBidder => {
  const { snackbar } = useSnackbar(bidderCode)
  const [checked, setChecked] = useState<boolean>(enabled)

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_WORKSPACE_BIDDER_FOR_PAGE,
    onCompleted: async (data: Data, variables): Promise<void> => {
      const { errors } = data.updateWorkspaceBidder
      const value = variables.input.enabled

      if (errors && errors.length > 0) {
        snackbar(value, 'error')
      } else {
        setChecked(value)
        snackbar(value)
      }
    },
  })

  const update = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
    const value: boolean = event.target.checked

    await mutateAsync({ input: { enabled: value, workspaceBidderId: id } })
  }

  return { checked, update }
}
